import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { LabelsSidebar } from '../labels_sidebar/LabelsSidebar';
import { Label, LabelEntityType } from '../../types/labels';
import { labelsOnAssetsRestCrudThunks, syncAssetLabels } from '../../thunks/asset_labels_thunks';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { RootState } from '../../reducers/root_reducer';
import { pickRandomLabelColor } from '../../constants/labelConstants';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { isUserAllowedToAccess, PERMISSION_NAMES } from '../../utils/AuthUtils';
import { withUserType } from '../withUserType';

interface OwnProps {
	onClose?: () => void;
	targetCollectionName: LabelEntityType;
	onLabelsCatalogueSaved?: () => void | Promise<void>;
	onLabelCountClick?: (label: Label) => void;
	userType: string;
}

const AssetsLabelsManagementPage: React.FC<any> = ({
	userType,
	companyConfig,
	currentUser,
	...props
}) => {
	const canModifyLabels = useMemo(
		() =>
			isUserAllowedToAccess(userType)(
				PERMISSION_NAMES.MODIFY_ASSET_LABELS,
				companyConfig,
				nullSafeGetOrElse('roles', currentUser, [])
			),
		[userType, companyConfig, currentUser]
	);

	return (
		<LabelsSidebar
			{...props}
			canModifyLabels={canModifyLabels}
			getCount={(label) => nullSafeGetOrElse('associatedAssetsCount', label, 0)}
			pickNewLabelColor={pickRandomLabelColor}
			deleteWarningEntityNoun="assets"
		/>
	);
};

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
	labels: getRecordsForTargetCollection(state.asset_labels, ownProps.targetCollectionName) || [],
	fetching: nullSafeGetOrElse('fetching', state.asset_labels[ownProps.targetCollectionName], false),
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch: any, ownProps: OwnProps) => ({
	fetchAllLabels: () =>
		dispatch(
			labelsOnAssetsRestCrudThunks(ownProps.userType).read(
				{ no_pagination: true },
				ownProps.targetCollectionName,
				null,
				{
					sort_by: 'associatedAssetsCount',
					order: 'desc',
				}
			)
		),
	syncLabels: (entries) =>
		dispatch(
			syncAssetLabels(ownProps.userType)(entries, {
				history: (ownProps as any).history,
				targetCollectionName: (ownProps as any).listTargetCollectionName,
			})
		),
});

// @ts-ignore - HOC composition type inference, same pattern as PartsLabelsManagementPage
export default withUserType(
	connect(mapStateToProps, mapDispatchToProps)(AssetsLabelsManagementPage)
);
